import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AdminContextService } from './admin.context.service';
import { CohortDO } from '../domain-model-dtos';
import { CurrencyDTO } from '../../components/data-type-widgets/data-type/lottomart/model/lottomart-model';

@Injectable()
export class CurrencyService {
  /** Kept outside money-form-field.component, so it doesnt react to every cohort change */
  private defaultCurrency: CurrencyDTO;

  constructor(
    private http: HttpClient,
    private adminContextService: AdminContextService
  ) {
    this.adminContextService.getCohortWatcher().subscribe((c) => {
      this.setCurrency(c);
    });
  }

  private setCurrency(cohort: CohortDO) {
    if (cohort) {
      this.defaultCurrency = cohort.currency;
    }
  }

  public getCurrencyForCurrentCohort(): CurrencyDTO {
    return this.defaultCurrency;
  }
}
